import React, { useMemo } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import { Icon } from '@buderus-apps/components'

type Props = {
  containerId: string
  onClick: (event: any) => void
}

const TriggerButton = ({ containerId, onClick }: Props) => {
  const { t } = useTranslation()

  const container = useMemo(() => document.getElementById(containerId)!, [containerId])

  return (
    <>
      {container &&
        createPortal(
          <button
            className={'ob-ai-search-trigger__button'}
            onClick={(event) => onClick(event)}
          >
            <span className={'ob-ai-search-trigger__button-container'}>
              <span className={'ob-icon ob-ai-search-trigger__icon'}>
                <Icon.ArtificialIntelligence />
              </span>
              <span className={'ob-ai-search-trigger__text'}>
                {t('AI_ASSISTENT')}
              </span>
            </span>
          </button>,
          container
        )}
    </>
  )
}

export default React.memo(TriggerButton)
